import { TaskStatus } from "../../../shared/constants/task-status";
import { TaskType } from "./constants";

const filterIEItems = (applicableSettings, itemDescription) => {
    let isDescriptionApplicable = false;

    Object.keys(applicableSettings.imageEditingBulkComplete).forEach((key) => {
        applicableSettings.imageEditingBulkComplete[key]?.applicableTaskDescriptions.forEach((description) => {
            if (description === itemDescription) {
                isDescriptionApplicable = true;
            }
        });
    });

    return isDescriptionApplicable;
};

export const approveRejectFilterStrategy =
    (sourcePage, settings) =>
    ({ state, description }) => {
        switch (sourcePage) {
            case TaskType.IE:
                return filterIEItems(settings, description) && state !== TaskStatus.COMPLETED;
            case TaskType.FINAL_QA:
                return state === TaskStatus.TO_DO || state === TaskStatus.REDO || state === TaskStatus.READY || state === TaskStatus.ACTIVE;
            default:
                return (
                    state === TaskStatus.TO_DO || state === TaskStatus.WAITING_FOR_CA || state === TaskStatus.REDO || state === TaskStatus.UPLOADED
                );
        }
    };

export const convertToCT = (dateTime) => {
    if (!dateTime) {
        return "";
    }

    return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "America/Chicago",
    })
        .format(new Date(dateTime))
        .replace(/, /g, " ");
};

export const isInteger = (num) => {
    return num % 1 === 0;
};
